<template>
  <div style="margin-left: 0px;">
    <div v-if="debug_show_page_name==true" style="color:green;">device-embedded-detail</div>
    <div :class="'container ' + pageContainerSize">
      <ag-grid-vue style="width: 100%; height: 100px" class="ag-blue" :gridOptions="gridOptions"></ag-grid-vue>
    </div>
    <div class="row" style="margin-top: 10px;">
      <div class=" col-xs-6" style="">
        <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
      </div>
      <div class="col-xs-6" style="">
        <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
      </div>
      <button
        v-if="hideNewBtn == false"
        :disabled="selected_row == Number.MAX_SAFE_INTEGER || disableNewBtn == true || read_only == false || checkUserPermission(true,permissionMode.ADD) == false"
        class="btn btn-primary"
        style="min-width:100px;width: 232px;float: right;margin-right: 5px;background: #43c9de;border-color:#43c9de;"
        @click="addNew">新規（組込情報）</button>

      <button v-show ="isAdminSavingApplication == true"
      :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
      v-if="read_only == false" class="btn btn-primary" style="min-width:100px;width: 108px;float: right;margin-right: 10px;background: #43c9de;border-color:#43c9de" @click="onSubTableDeviceEmbeddedInformationAddCheckConfirmdri" >上書登録</button>
      <button v-show ="isAdminSavingApplication == false && approvalMode == false"
      :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
      v-if="read_only == false" class="btn btn-primary" style="min-width:100px;width: 108px;float: right;margin-right: 10px;background: #43c9de;border-color:#43c9de" @click="onLocalSaveSubDevEmbedded" >下書登録</button>
      <button v-show ="isAdminSavingApplication == false && approvalMode == true"
      :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
      v-if="read_only == false" class="btn btn-primary" style="min-width:100px;width: 108px;float: right;margin-right: 10px;background: #43c9de;border-color:#43c9de" @click="onLocalSaveSubDevEmbeddedOnApprove" >上書保存</button>
      <button
      :disabled="disableCancel"
      v-if="read_only == false" class="btn btn-primary" style="min-width:100px;width: 109px;float: right;margin-right: 10px;background: #A6A6A6;border-color:#A6A6A6;" @click="btnCancel" >キャンセル</button>

      <button v-else
        v-show="hideEditBtn == false"
        :disabled="selected_row == -1 || disableEditBtn == true || checkUserPermission(true,permissionMode.EDIT) == false"
        class="btn btn-primary"
        style="min-width:100px;width: 227px;float: right;margin-right: 10px;background: #43c9de;border-color:#43c9de;"
        @click="onEdit">編集（組込情報）</button>
        <button
        v-show="hideEditBtn == false"
        :disabled="disableDelete || checkUserPermission(true,permissionMode.DELETE) == false"
        class="btn btn-primary" style="min-width:100px;width: 240px;float:right;margin-right: 7px;background: #ed791a;border-color:#ed791a;" @click="onDelete" >{{deleteText}}</button>
    </div>
    <confirmation-modal-device-link tag="showConfimationModalSetYobiki" @done="confirmedSetYobiki"></confirmation-modal-device-link>
    <yobiki-modal tag="showYobikiModal" @selected="onYobikiModalSelected"></yobiki-modal>
    <confirmation-modal tag="deleteDeiveEmbeddedDetailModal" @done="onConfirmDelete" />
    <confirmation-modal tag="notificationAfterSaveDetails" />
    <confirmation-modal tag="confirmSubDeviceEmbeddedInformationAddCheck" @done="onSubTableDeviceEmbeddedInformationAddCheckConfirm" />
    <confirmation-modal tag="confirmSubDeviceEmbeddedInformationAddCheckOnApprove" @done="onSubTableDeviceEmbeddedInformationAddCheckConfirmOnApprove" />
  </div>
</template>

<script>
import deviceembeddedinformationaddcheck from '@/components/modals/device-embedded-information-add_check';
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_device_embedded_detail";
import { utils } from "@/libs/utils";
import fieldBoxes from '@/components/form-field';

import _debug from "debug";
import async from "async";
var mdebug = _debug("esma:device_embedded_detail");
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";
import yobikiModal from "@/components/modals/yobiki-modal";
import confirmationModalDeviceLink from "@/components/modals/confirmation-modal-device-link";
Vue.component("yobiki-modal", yobikiModal);
import constants from '@/rules/constants';

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "ag-grid-vue": AgGridVue,
    'field-box': fieldBoxes,
    'confirmation-modal-device-link':confirmationModalDeviceLink
  },
  data() {
    return {
      api_name: "device_embedded_detail",
      page_acl: acl.device_embedded_detail,
      detail_page: "page_0015_device_embedded_information_pegging",
      detail_page_url: "/device_embedded_information_pegging/",
      state_current_editing:"current_editing2",
      state_current_row:"current_row2",
      state_is_editing_new:"is_editing_new2",
      state_last_filter_options:"last_filter_options2",
      temp_certificate_management_number:"",
      temp_certificate_management_data:false,
      local_fk_id: -1,
      disable_cancel:false,
      last_selected_software_jurisdiction:false,
      processing_software_jurisdiction:false,
      software_jurisdictio_update_fields : [
        {from:"equipment_in_charge_classification",  to:"jurisdiction_classification"},
        {from:"equipment_in_charge_department",  to:"department_in_charge"},
        {from:"equipment_in_charge_team",  to:"responsible_team"},
        {from:"equipment_in_charge_system_it",  to:"jurisdiction_system"},
        {from:"equipment_in_charge_system",  to:"jurisdiction_system_name_in_use"}
      ]

    };
  },
  computed: {
    disableCancel:{
      get(){
        return this.disable_cancel;
      },
      set(v){
        this.disable_cancel = v;
      }
    },
    totalNumberOfRows:{
      get(){
        return this.total_number_of_rows;
      },
      set(v){
        this.$emit('updatedtotalnumber', v);       
        this.total_number_of_rows = v;
      }
    },
    deleteText(){
      if(this.disableDelete || this.formOutputQty  == 0){
        return "削除（組込情報）";
      }else{
        return "削除（組込情報）(" + this.formOutputQty + ")";
      }
    },
    disableDelete(){
      if(this.formOutputQty > 0 && (Array.isArray(this.selectedRowArr) && this.selectedRowArr.length > 0) ){
        return false;
        // return typeof _.find(this.selectedRowArr,(d)=>{ return d.certificate_management_number != "" && d.certificate_management_number != null}) != "undefined";
      }else{
        return true
        // if( isNaN(this.selected_row) == false && this.selected_row > -1
        // && (this.certificateManagementNumber == null || this.certificateManagementNumber.length == 0)){
        //   return this.read_only == false;
        // }else{
        //   return true
        // }
      }
    },
    certificateManagementNumber(){
      return _.get(this.$store.state,this.stateCurrentEditing+".certificate_management_number", _.get(this.$store.state,this.stateCurrentRow+".certificate_management_number",""))
    },
    isAdminSavingApplication (){
      return this.isAdmin && this.loadBy == 'fk_id';
    },
    disableNewBtn(){
      return this.$props.disable_new_btn;
    },
    disableEditBtn(){
      return this.$props.disable_edit_btn;
    },
    hideNewBtn(){
      return this.$props.hide_new_btn;
    },
    hideEditBtn(){
      return this.$props.hide_edit_btn;
    },
    readOnly:{
      get(){
        return this.read_only;
      },
      set(v){
        this.read_only = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields() {
      return this.tabFieldList;
    },
    values() {
      console.log('TEST DEBUG 210803 (170 at device-embedded-detail.vue)[23:38]: ', {data_values: this.data_values });
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        this.local_extend( fields.jurisdiction_classification, {
            on_set_value:(data) =>{
              setTimeout(() => {
              this.processJurisdictionClassification("tabFieldList/on_set_value",data)
              },300);
            }
        }),
        this.local_extend( fields.department_in_charge, {}),
        this.local_extend( fields.responsible_team, {}),

        this.local_extend( fields.jurisdiction_system, {
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;" ,
            // This part was moved to processJurisdictionClassification at disableExternalField
            // listen_for: [
            //   {
            //     name: "upd_virtual_base_unit_it",
            //     // mode: "disable_and_clean_if_value",
            //     mode: "disable_and_set_message_if_value",
            //     msg:"所管区分：EUC・その他を選択した場合は入力不要",
            //     disable_if_value: true
            //   }
            // ],

        }),
        this.local_extend( fields.jurisdiction_system_name_in_use, {
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;" ,
            listen_for: [
              {
                name: "upd_virtual_base_unit",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
        }),

        this.local_extend( fields.maker, {}),
        this.local_extend( fields.software, {}),
        this.local_extend( fields.software_jurisdiction, {}),
        this.local_extend( fields.item_number, {}),
        this.local_extend( fields.virtual_id, {}),
        this.local_extend( fields.certificate_management_number, {})
      ];
    },
    formFields() {
      return {
        col1:[
          this.local_extend(fields.jurisdiction_classification, {}),
          this.local_extend(fields.department_in_charge, {
            default_from_local_storage:false
          }),
          this.local_extend(fields.responsible_team, {
            default_from_local_storage:false
          }),
          this.local_extend(fields.jurisdiction_system, {}),
          this.local_extend(fields.jurisdiction_system_name_in_use, {}),
          this.local_extend(fields.maker, {}),
        ],
        col2:[
          this.local_extend(fields.software, {}),
          this.local_extend(fields.software_jurisdiction, {
             on_set_value:(data) =>{
               this.processing_software_jurisdiction = true;
              this.last_selected_software_jurisdiction = data;

              this.disableExternalField("formFields_1","item_number",data == "プレインストール",true);
              this.disableExternalField("formFields_2","certificate_management_number",data == "プレインストール" || data == "リース/レンタル",true,true);

              this.disableExternalField("formFields_2.1","maker",data != "プレインストール" && data != "リース/レンタル" &&  this.getFieldLastValue("certificate_management_number","") != "",true,true);
              this.disableExternalField("formFields_2.2","software",data != "プレインストール" && data != "リース/レンタル" &&  this.getFieldLastValue("certificate_management_number","") != "",true,true);

              if(data == "当該部署所管" && this.getFieldLastValue("certificate_management_number","") == ""){
                  // this.disableExternalField("formFields_3","certificate_management_number",data == "プレインストール",true,true,"CLEAR_VALUE");
                  this.software_jurisdictio_update_fields.forEach(ch_fld =>{
                    var org_val =  this.$store.state["current_editing"][ch_fld.from] || this.$store.state["current_row"][ch_fld.from]|| "CLEAR_VALUE";
                    this.disableExternalField("formFields_4.1",ch_fld.to,true,false,true,org_val);
                    this.processSoftwareJurisdiction(data,null,()=>{
                      this.processing_software_jurisdiction = false;
                    });
                  })
              }else if(this.readOnly == false){
                if(data == "プレインストール"){
                  this.disableExternalField("formFields_3","certificate_management_number",data == "プレインストール",true,true,"CLEAR_VALUE");
                  this.software_jurisdictio_update_fields.forEach(ch_fld =>{
                    var org_val =  this.$store.state["current_editing"][ch_fld.from] || this.$store.state["current_row"][ch_fld.from]|| "CLEAR_VALUE";
                    this.disableExternalField("formFields_4",ch_fld.to,true,true,true,org_val);
                  })
                }else if(this.getFieldLastValue("certificate_management_number","") == ""){
                  this.software_jurisdictio_update_fields.forEach(ch_fld =>{
                    this.disableExternalField("formFields_5",ch_fld.to,true,true,true,"CLEAR_VALUE");
                  })
                }
              }

              this.processSoftwareJurisdiction(data,null,()=>{
                this.processing_software_jurisdiction = false;
              });
            }
          }),
          this.local_extend(fields.item_number, {}),
          this.local_extend(fields.virtual_id, {}),
          this.local_extend(fields.certificate_management_number, {
            on_set_value:(data) =>{
              if(this.processing_software_jurisdiction == false){
                setTimeout(() => {
                  this.disableExternalField("formFields_6","maker",true,true,true);
                  this.disableExternalField("formFields_7","software",true,true,true);
                  this.processSoftwareJurisdiction(null,data);
                }, 200);
              }
            },
            disabled: false,
            required: true,
            force_readonly: true,
            field_style: " width: 100%;display: block;" ,
            buttons: [
              {
                  btn_style:"width:100%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 10px;background: #43c9de;border-color:#43c9de;",
                  type:"callback",
                  callback:(b)=>{
                    this.yobikiPopUp()
                  },
                  label:"証書"// Need the spec.
              }
          ]
          }),
        ]
      }
    },
    approvalMode(){
      return this.$route.meta.approval_mode || false;
    }
  },
  methods: {
    processSoftwareJurisdiction(software_jurisdiction,certificate_management_number,cb=()=>{}){
      var fields_arr = ["maker","software"]
      var fields_arr_disable_for_all = ["jurisdiction_classification","department_in_charge","responsible_team","jurisdiction_system","jurisdiction_system_name_in_use"]
      software_jurisdiction = software_jurisdiction || this.getFieldLastValue("software_jurisdiction")
      certificate_management_number = certificate_management_number || this.getFieldLastValue("certificate_management_number","")
      fields_arr_disable_for_all.forEach(f=>{
        this.disableExternalField("processSoftwareJurisdiction_1",f,true)
      })
      if(software_jurisdiction ==  "リース/レンタル"){
        this.software_jurisdictio_update_fields.forEach(ch_fld =>{
          var org_val =  this.getFieldLastValue(ch_fld.to,"CLEAR_VALUE")
          this.disableExternalField("processSoftwareJurisdiction_4",ch_fld.to,false,true,true)//,true,true,org_val);
          this.disableExternalField("processSoftwareJurisdiction_4",ch_fld.to,false,false,true)//,true,true,org_val);
        })
        fields_arr.forEach(f=>{
          this.disableExternalField("processSoftwareJurisdiction_5",f,false)
        })
      }else if(software_jurisdiction == "当該部署所管" || certificate_management_number == "" || certificate_management_number == null){
        fields_arr.forEach(f=>{
          this.disableExternalField("processSoftwareJurisdiction_2",f,false)
        })
      }else{
        fields_arr.forEach(f=>{
          this.disableExternalField("processSoftwareJurisdiction_3",f,true)
        })
      }
      setTimeout(() => {
        if(this.local_fields_ref && this.local_fields_ref.jurisdiction_classification && this.local_fields_ref.jurisdiction_classification.ref_field){
          return this.processJurisdictionClassification("process SoftwareJurisdiction",this.local_fields_ref.jurisdiction_classification.ref_field.fieldValue,cb)

        }else{
          return cb();
        }
      },100)
    },
    processJurisdictionClassification(requester, data,cb=()=>{}){
      if(data == " " || data == ""){
        if(this.read_only == false){
          setTimeout(()=>{
            var jurisdiction_classification =  this.getFieldLastValue("jurisdiction_classification","")
            if(jurisdiction_classification == "" ||  jurisdiction_classification == " "){
              this.disableExternalField(requester + ">"+"process JurisdictionClassification_8","jurisdiction_system",false, true,false,"CLEAR_VALUE")
              this.disableExternalField(requester + ">"+"process JurisdictionClassification_2","jurisdiction_system_name_in_use",false, true,false,"CLEAR_VALUE")
            }
            return cb();
          },300)
        }
      }else if(data == "IT所管システム"){
        if(this.read_only == false){
          var jurisdiction_system =  this.getFieldLastValue("jurisdiction_system","")

          if(jurisdiction_system == "所管区分：EUC・その他を選択した場合は入力不要"){
            this.disableExternalField(requester + ">"+"process JurisdictionClassification_1","jurisdiction_system",false, true,true,"CLEAR_VALUE")
          }else{
            this.disableExternalField(requester + ">"+"process JurisdictionClassification_1","jurisdiction_system",false, true,true)
          }
          this.disableExternalField(requester + ">"+"process JurisdictionClassification_2","jurisdiction_system_name_in_use",true, true)
          return cb();
        }
      }else if(data == "EUC・その他"){
        if(this.read_only == false){
          this.disableExternalField(requester + ">"+"process JurisdictionClassification_3","jurisdiction_system_name_in_use",false, true)
          // this.disableExternalField(requester + ">"+"process JurisdictionClassification_4","jurisdiction_system",true, true)
        }
        var software_jurisdiction =  this.getFieldLastValue("software_jurisdiction","")
        if(software_jurisdiction ==  "リース/レンタル"){
          if(this.read_only == true){
            this.disableExternalField(requester + ">"+"process JurisdictionClassification_4","jurisdiction_system",false, true,false,"所管区分：EUC・その他を選択した場合は入力不要")
          }else{
            this.disableExternalField(requester + ">"+  "process JurisdictionClassification_5","jurisdiction_system",true, true,false,"所管区分：EUC・その他を選択した場合は入力不要")
          }
        }else if(software_jurisdiction ==  "他部署所管"){
          this.disableExternalField(requester + ">"+  "process JurisdictionClassification_6","jurisdiction_system",true, true,false,"CLEAR_VALUE")
        }else{
          this.disableExternalField(requester + ">"+"process JurisdictionClassification_7","jurisdiction_system",false, true,false,"所管区分：EUC・その他を選択した場合は入力不要")
        }
        return cb();
      }
    },
    disableExternalField(requester, field_id, disable, local=false, force_preserve_value=false, set_value=false){
      if(this.local_fields_ref && this.local_fields_ref[field_id] && this.local_fields_ref[field_id].ref_field){
        var edited_value = false;
        if(force_preserve_value){
          edited_value = this.getFieldLastValue(field_id,"")
        }
        if(local){
          this.local_fields_ref[field_id].ref_field.localDisabled = disable;
        }else{
          this.local_fields_ref[field_id].ref_field.externalDisabled = disable;
        }
        if(force_preserve_value && edited_value){
            this.$store.state[this.stateCurrentRow][field_id] = edited_value;
            this.local_fields_ref[field_id].ref_field.updateValue(edited_value);
            this.local_fields_ref[field_id].ref_field.localRefreshSequecnce++;
        }
        if(set_value){
          if(set_value == "CLEAR_VALUE"){
            set_value = "";
          }
          this.$store.state[this.stateCurrentRow][field_id] = set_value;
          this.local_fields_ref[field_id].ref_field.updateValue(set_value);
          this.local_fields_ref[field_id].ref_field.localRefreshSequecnce++;
        }
      }
    },
    onDelete(){
      bus.$emit("deleteDeiveEmbeddedDetailModal",{
        title: "削除",
        message: "組込情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        if(Array.isArray(this.selectedRowArr) && this.selectedRowArr.length > 0){
          var arr = this.selectedRowArr.map((m)=>{return m.seq_id;})
          var vm = this
          this.commonDeleteArr(vm,arr,()=>{
            vm.reloadDataAfterDelete(vm);
          })
        }else{
          this.commonDelete(this, (err,result,vm)=>{
            vm.reloadDataAfterDelete(vm);
          });
        }
      }
    },
    reloadDataAfterDelete(vm){
      vm.gridOptions.api.purgeInfiniteCache();
      vm.countRows("onConfirmDelete");
      vm.$store.state[vm.stateCurrentRow] = {}
      vm.$store.state[vm.stateCurrentEditing] = {}
      vm.selected_row = -1;
      vm.selectedRowArr = []
    },
    local_extend(field_info,ext){
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      var r = utils.extend(field_info,ext)
      this.local_fields_ref[r.id] = r;
      return r;
    },
    btnCancel() {
      this.commonValidateFieldsClear(this,()=>{})
        this.cancelCurrentSelection(true);
    },

    validateItemNumberQty(cb){
      // this.$ajax.post('/certificate_software/get/'+this.temp_certificate_management_data.seq_id, {}, (err, result) => {
      this.$notify({
        title: "エラー",
        text: "割り当てるライセンス数がライセンス残数を上回っています。",
        type: "error",
        duration: 10000
      });
      cb()

    },
    onSubTableDeviceEmbeddedInformationAddCheckConfirmdri(mode){
      this.validateItemNumberQty((err)=>{
        if(err){
          return;
        }
        this.readOnly = false;
        this.commonSaveInfo(this,this.api_name, {} );
      })
    },
    onLocalSaveSubDevEmbeddedOnApprove(){
      this.commonValidateFields(this,{},(error_found)=>{
        if(error_found != false){
          return;
        }
        if(this.is_new == false){
          this.saveEditClicked = true;
        }
        bus.$emit("confirmSubDeviceEmbeddedInformationAddCheckOnApprove",{
          message:  "よろしいですか？",
          title: "登録情報を上書保存します。", // KONUMA-SAN PLEASE CHECK HERE IF THE 上書 IS CORRECT [1631435478]: 
          yes_label: "上書保存", // KONUMA-SAN PLEASE CHECK HERE IF THE 上書 IS CORRECT [1631435478]: 
          no_label: "戻る",
          yes_color:"primary",
          no_color:"",
          model_height:"50"
        });
      });
    },
    onSubTableDeviceEmbeddedInformationAddCheckConfirmOnApprove(mode){
      if(mode == "yes"){
        this.validateItemNumberQty((err)=>{
          if(err){
            return;
          }
          this.commonValidateFields(this,{},(error_found)=>{
            if(error_found != false){
              return;
            }
            this.readOnly = false;
            this.commonSaveInfo(this,this.api_name, {}, (err)=>{
              if(err){
              }else{
                bus.$emit("notificationAfterSaveDetails",{
                  message: "",
                  title: "登録情報を上書保存しました。", // KONUMA-SAN PLEASE CHECK HERE IF THE 上書 IS CORRECT [1631435478]: 
                  yes_label: "",
                  no_label: "OK",
                  yes_color:"",
                  no_color:"",
                  model_height:"50"
                });
              }
            });
          });
        })
      }
    },
    onLocalSaveSubDevEmbedded(){
      var message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>承認状態が【下書中】となるので、申請が必要になります。</span>";
      //if(this.is_new == true){
        if(this.showapprovalStatus == true) {
        message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>※承認状態が【承認済】のものは【下書中】になります。 </span>";
      }
      this.commonValidateFields(this,{},(error_found)=>{
        if(error_found != false){
          return;
        }
        if(this.is_new == false){
          this.saveEditClicked = true;
        }
        console.log("onLocalSave")
        bus.$emit("confirmSubDeviceEmbeddedInformationAddCheck",{
          message:  message,
          title: "登録情報を下書保存します。",
          yes_label: "下書保存",
          no_label: "戻る",
          yes_color:"primary",
          no_color:"",
          model_height:"100",
          model_width: "450px"
        });
      });
    },
    onSubTableDeviceEmbeddedInformationAddCheckConfirm(mode){
      if(mode == "yes"){
        this.validateItemNumberQty((err)=>{
          if(err){
            return;
          }

          this.commonValidateFields(this,{},(error_found)=>{
            if(error_found != false){
              return;
            }
            this.readOnly = false;
            this.$emit("data-saved",(err)=>{
              if(err == null){
                this.commonSaveInfo(this,this.api_name, {}, (err)=>{
                  if(err){
                  }else{
                    bus.$emit("notificationAfterSaveDetails",{
                      message: "",
                      title: "登録情報を下書保存しました。",
                      yes_label: "",
                      no_label: "OK",
                      yes_color:"",
                      no_color:"",
                      model_height:"50"
                    });
                  }
                });
              }else{
                this.disableCancel = true;
              }
            })
          });
        })
      }
    },
    onDetailsClick(ev, data) {
      this.$notify({clean:true});
      if(data.certificate_management_number && data.certificate_management_number.length >0){
        window.sessionStorage.setItem('certificate_back_to_list', "/device_embedded_information/" + this.local_fk_id)
        return this.$router.push( "/certificate/n/" + data.certificate_management_number);
      }else{
        this.$notify({
          title: "エラー",
          text: "証書情報とのリンクはありません。",
          type: "error",
          duration: 2000
        });
      }
    },
    createColumnDefs() {
      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(f => {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        arr.push(fi);
      });
      [utils.extend(this.fieldList.more_details, {tab_label:"-"}),this.fieldList.button_options].forEach(f => {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          cellRenderer: params => {
            if (params.column.colId == "more_details") {
              return this.createLocalGridTextButton(
                "証書",
                this.onDetailsClick,
                params.data
              );
            }
            if (params.column.colId == "button_options") {
              return this.createGridButton(
                "glyphicon glyphicon glyphicon-unchecked",
                "color: #5b9bd5;",
                this.onSelectedClickDatasource,
                params.data
              );
            }
          }
        };
        arr.push(fi);
      });
      return arr;
    },
    createLocalGridTextButton(text, onClick, row_data) {
      var center = document.createElement('center');
      var btn = document.createElement('button');
      btn.style.cssText="padding: 0px 5px;margin-top:-2px;" + (!(row_data && row_data.certificate_management_number && row_data.certificate_management_number.length >0)?";background:#ccc;border:solid 1px #bbb;":"")
      btn.className = "btn btn-primary btn-xs"
      btn.innerHTML = ''+text+'';
      btn.addEventListener('click', (ev,data) => {
        onClick(ev, row_data)
      });
      center.appendChild(btn)
      return center;
    },
    onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
      this.$store.state[this.stateCurrentEditing] = {}
      this.$store.state[this.stateCurrentRow] = {}
      this.commonOnRowSelected(this, ev, this.api_name,(vm)=>{
        if(typeof vm.$store.state[vm.stateCurrentEditing].certificate_management_number == "undefined" ||  vm.$store.state[vm.stateCurrentEditing].certificate_management_number == null ||  vm.$store.state[vm.stateCurrentEditing].certificate_management_number == ""){
           vm.$store.state[vm.stateCurrentEditing].certificate_management_number = vm.$store.state[vm.stateCurrentRow].certificate_management_number || "";
        }
      })
    },
    onEdit(){
      this.disableCancel = false;
      mdebug("onEdit")
      if(this.local_fields_ref["jurisdiction_classification"] && this.local_fields_ref["jurisdiction_classification"].ref_field && this.local_fields_ref["jurisdiction_classification"].ref_field.data && this.local_fields_ref["jurisdiction_classification"].ref_field.data.options){
        if(this.local_fields_ref["jurisdiction_classification"].ref_field.data.options[0] == " "){
          this.local_fields_ref["jurisdiction_classification"].ref_field.data.options.shift()
        }
      }
      setTimeout(() => {
        this.readOnly = false;
        if(this.local_fields_ref && this.local_fields_ref.jurisdiction_classification && this.local_fields_ref.jurisdiction_classification.ref_field){
          this.processJurisdictionClassification("onEdit",this.local_fields_ref.jurisdiction_classification.ref_field.fieldValue)
        }
      }, 300);
    },
    addNew(){
      this.disableCancel = false;
      this.local_seq_id = Number.MAX_SAFE_INTEGER;
      this.selected_row = Number.MAX_SAFE_INTEGER;
      this.$store.state[this.stateCurrentRow] = {}
      this.$store.state[this.stateCurrentRow]= {
        seq_id : this.local_seq_id,
        ref_id : this.$props.ref_id,
        fk_id: this.local_fk_id,
        fk_tab: constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION
      }
      this.$store.state[this.stateCurrentEditing] = {};
      this.$store.state[this.stateCurrentEditing]= {
        ref_id : this.$props.ref_id,
        fk_id: this.local_fk_id,
        fk_tab: constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION
      }

      this.allFields.forEach(f =>{
        this.$store.state[this.stateCurrentRow][f.id] = "";
      })
      setTimeout(() => {
        this.$store.state[this.stateIsEditingNew] = true;
        this.read_only = false;
        this.is_new = true;
      }, 300);
      mdebug("mounted as new")
      if(this.local_fields_ref["jurisdiction_classification"] && this.local_fields_ref["jurisdiction_classification"].ref_field && this.local_fields_ref["jurisdiction_classification"].ref_field.data && this.local_fields_ref["jurisdiction_classification"].ref_field.data.options){
        if(this.local_fields_ref["jurisdiction_classification"].ref_field.data.options.indexOf(" ") < 0){
          this.local_fields_ref["jurisdiction_classification"].ref_field.data.options.unshift(" ")
        }
      }
    },
    confirmedSetYobiki(mode,qty){
      if(mode == "yes"){
        console.log('TEST DEBUG 210508 (443 at device-embedded-detail.vue)[01:01]: ', { num: this.temp_certificate_management_number, mode, qty });
        bus.$emit("management_number_force_update",this.temp_certificate_management_number );
        bus.$emit("licence_item_number_force_update",qty);
      // this.$store.state[this.stateCurrentEditing].item_number = qty;
      // this.$store.state[this.stateCurrentRow].item_number = qty;

      this.localCertificateDetails();

      }else if(mode == "no"){
          // return bus.$emit("showYobikiModal"),{device_control_number:this.local_fk_id};
          return bus.$emit("showYobikiModal",{device_control_number:this.local_fk_id,software_jurisdiction:this.last_selected_software_jurisdiction});
      }
    },
    localCertificateDetails(){
      if(this.isObject(this.temp_certificate_management_data) && isNaN(this.temp_certificate_management_data.seq_id) == false && this.temp_certificate_management_data.seq_id > -1 ){
        this.$ajax.post('/certificate_software/get/'+this.temp_certificate_management_data.seq_id, {}, (err, result) => {
          if(err){
            this.$notify({
              title: "エラー",
              text: "Can not find related 証書情報 data.",
              type: "error",
              duration: 2000
            });
          }else if(this.isObject(result) && this.isObject(result.data)){
            // Set the sofware name
            bus.$emit("software_force_update",this.temp_certificate_management_data.software_name);
            // Set the other fields.
            var upd_fld_list = [
              {from:"jurisdiction_classification",to:"jurisdiction_classification_force_update"},
              {from:"licensed_department",to:"department_in_charge_force_update"},
              {from:"license_jurisdiction_team",to:"responsible_team_force_update"},
              {from:"maker",to:"maker_force_update"}
            ];
            if(result && result.data && result.data.jurisdiction_classification == "IT所管システム"){
              upd_fld_list.push({from:"license_jurisdiction_system",to:"jurisdiction_system_force_update"})
            }else if(result && result.data && result.data.jurisdiction_classification == "EUC・その他"){
              upd_fld_list.push({from:"equipment_in_charge_system",to:"jurisdiction_system_name_in_use_force_update"})
            }else{
            }


            async.mapLimit(upd_fld_list, 1, (ufl, done) => {
              setTimeout(() => {
                bus.$emit(ufl.to,result.data[ufl.from]);
                done();
              }, 150);
              bus.$emit(ufl.to,result.data[ufl.from]);
            }, (err, allDone) => {
              // Finished.
            })
          }
        })
      }
    },
    yobikiPopUp(){
      bus.$emit("showYobikiModal",{device_control_number:this.local_fk_id,software_jurisdiction:this.last_selected_software_jurisdiction});
    },
    onYobikiModalSelected(val, row){
      if(val && val.length > 0){
        this.temp_certificate_management_data = false;
        if(row){
          this.temp_certificate_management_data = row;
        }
        console.log('TEST DEBUG 210508 (529 at device-embedded-detail.vue)[01:39]: ', { row });
          bus.$emit("showConfimationModalSetYobiki", {
                title:"",
                link_number:val,
                max_qty:row.remaining_number || false
              })
        this.temp_certificate_management_number = val;
      }
    },
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    console.log("device_embedded_detail mounted")
    if(this.$props.tag_reload && this.$props.tag_reload.length > 0){
      bus.$on(this.$props.tag_reload, (data) => {
        setTimeout(()=>{
          if(data.fk_id && isNaN(data.fk_id) == false && data.fk_id > 0){
            this.local_fk_id = data.fk_id;
            this.searchControlChangedDatasource(this.singleSearchCreate("fk_id","" + data.fk_id))
          }else if(data.clear_list && isNaN(data.clear_list) == false && data.clear_list == true){
            var selected_row = this.selected_row;
            this.gridOptions.api.purgeInfiniteCache();
              this.countRows("device-embedded-detail");
            if(this.$store.state[this.stateCurrentRow].software_jurisdiction == "プレインストール" || this.$store.state[this.stateCurrentEditing].software_jurisdiction == "プレインストール"){
              if(selected_row != Number.MAX_SAFE_INTEGER){
                this.commonLoadRecord({force_seq_id:selected_row})
              }
            }
          }
        },10)
      })
    }
  },
  beforeDestroy() {
    if(this.$props.tag_reload && this.$props.tag_reload.length > 0){
      bus.$off(this.$props.tag_reload)
    }
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter:true});
  },
  props: {
    ref_id: { type: String, default: "" },
    // fk_id: { type: Number, default: "" },
    tag_reload: { type: String, default: "" },
    disable_new_btn: { type: Boolean, default: false },
    disable_edit_btn: { type: Boolean, default: false },
    hide_new_btn: { type: Boolean, default: false },
    hide_edit_btn: { type: Boolean, default: false },
  },
};
</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// device-embedded-detail.vue?70508e82